import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import CustomersBanner from "../ones/CustomersBanner";
import HomeBanner3 from "../ones/HomeBanner3";
import PartnersBanner from "../ones/PartnersBanner";
import HomeBanner0 from "../ones/HomeBanner0";
import HomeSlider from "../ones/HomeSlider";
import IntroPara from "../ones/IntroPara";
import CustomersHighlight from "../ones/CustomersHighlight";
import FeaturedProducts from "../ones/FeaturedProducts";
import CoreServices from "../ones/CoreServices";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<HomeBanner0/>
				<IntroPara/>
				<FeaturedProducts/>
				<HomeBanner1/>
				<CustomersHighlight/>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}